import React, { useMemo, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import FaucetBalanceChecker from "./faucet/FaucetBalanceChecker";
import FaucetFormComponent from "./faucet/FaucetFormComponent";
import FaucetRequestTable from "./faucet/FaucetRequestTable";
import FaucetCreateAccountButton from "./faucet/FaucetCreateAccountButton";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./FaucetBox.scss";
import "./faucet/FaucetFormComponent.scss";

const mock = {
  isAuthenticated: true,
  user: {
    sub: "mock",
  },
  isLoading: false
};

const servers = [
  {
    id: "pdsapi",
    name: "PDS API",
  },
  {
    id: "beta",
    name: "Beta",
  },
  {
    id: "acceptance",
    name: "Acceptance",
  },
];

function FaucetBox() {
  const [currentServer, setCurrentServer] = useState(servers[0]);
  const [funding, setFunding] = useState("debit");
  const getEndpoint = useMemo(() => {
    const endpoint =
      funding === "debit" ? "balances" : "fundings";
    return `https://${currentServer.id}.dase.io:8081/api/v37/${endpoint}`;
  }, [currentServer, funding]);
  let { isAuthenticated, user, isLoading } = useAuth0();

  if (window.Cypress) {
    isAuthenticated = mock.isAuthenticated;
    user = mock.user;
    isLoading = mock.isLoading;
  }

  return (
    
    <Section
    color='white'
    size='large'
    backgroundImage="halftone-1696560535.svg"
    backgroundImageOpacity={1}
    >
    
      <div className="container">
        <div className="faucet-illustration-container has-text-centered">
          <img src="pds-portfolio-loading-animation.gif" alt="Illustration" />
        </div>
        <SectionHeader
          title="Żetonium Testnet Faucet"
          subtitle={isLoading ? "Loading..." : "Request testnet Żetons for your account"}
          size={1}
          spaced={true}
          className="has-text-centered"
        />

        {isAuthenticated &&
          <div className="box">
            <div className="faucet-container">
              <div className="faucet-cell-container">
                <div className="faucet-cell">
                  <h1>Testnet</h1>
                  <div className="select">
                    <select
                      value={currentServer.id}
                      onChange={(e) =>
                        setCurrentServer(
                          servers.filter((item) => item.id === e.target.value)[0]
                        )
                      }
                      data-cy="select-server"
                    >
                      {servers.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="faucet-cell-container">
                <div className="faucet-cell">
                  <h1>Type of funding</h1>
                  <div className="select" style={{ width:"110px" }}>
                    <select
                      value={funding}
                      onChange={(e) => setFunding(e.target.value)}
                      data-cy="select-funding"
                    >
                      <option value="debit">Debit</option>
                      <option value="credit">Credit</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="faucet-cell-container">
                <div className="faucet-cell">
                  <FaucetFormComponent
                    endpoint={getEndpoint}
                    funding={funding}
                    buttonText={`Fund ${currentServer.name}`}
                    title={`${currentServer.name} Faucet`}
                    serverId={currentServer.id}
                    user={user}
                  />
                </div>
              </div>
              <div className="faucet-cell-container">
                <div className="faucet-cell">
                  <h1>Faucet Balance</h1>
                  <FaucetBalanceChecker server={currentServer.id} />
                </div>
              </div>
              <div className="faucet-cell-container">
                <div className="faucet-cell">
                  <FaucetRequestTable
                    funding={funding}
                    endpoint={getEndpoint}
                  />
                </div>
              </div>
              <div className="faucet-cell-container">
                <div className="faucet-cell">
                  <FaucetCreateAccountButton />
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </Section>
  );
}

export default FaucetBox;
